export function contributorDepartmentPath(departmentId: string): string {
  return `/contributor/departments/${encodeURIComponent(departmentId)}`;
}

export function parseContributorDepartmentId(pathname: string): string | undefined {
  const parts = pathname.replace(/\/$/, "").split("/").filter(Boolean);
  if (parts[0] !== "contributor") return undefined;
  if (parts.length === 2 && parts[1] !== "departments") return decodeURIComponent(parts[1]);
  if (parts.length === 3 && parts[1] === "departments" && parts[2]) return decodeURIComponent(parts[2]);
  return undefined;
}
